package pt.at.oss.kotlin.core.i18n

/**
 * Identifiers for i18n catalogs retrievable from the server.
 */
enum class I18nCatalogId {
    SITUACAO_REGISTO,
    SITUACAO_DECLARACAO,
    SITUACAO_LIQUIDACAO_DECL,
    SITUACAO_PAGAMENTO_DECL,
    SITUACAO_DECLARACAO_C,
    SITUACAO_LIQUIDACAO_DECL_C,
    SITUACAO_PAGAMENTO_DECL_C,
    SITUACAO_DETALHE_PAGAMENTO_DROPDOWN,
    SITUACAO_PAGAMENTO_DECL_DROPDOWN,
    ESTADO_LIQUIDACAO,
    ESTADO_LIQUIDACAO_C,
    CODIGO_ERRO_LIQUIDACAO,
    CODIGO_ERRO_LIQUIDACAO_C,
    SITUACAO_PEDIDO_INFORMACAO,
    TIPO_PAGAMENTO_PARCIAL,
    TIPO_PAGAMENTO_PARCIAL_C,
    SITUACAO_PAGAMENTO_NETP,
    SITUACAO_PAGAMENTO_NETP_C,
    SITUACAO_INFO_PAGAMENTO,
    SITUACAO_INFO_PAGAMENTO_C,
    TIPO_ERRO_DET_PAGAMENTO,
    SITUACAO_MENSAGEM_CCN,
    TIPO_PEDIDO_INFORMACAO,
    TIPO_PEDIDO_INFORMACAO_DECL,
    TIPO_PEDIDO_INFORMACAO_REG,
    NETP_INT_STATUS,
    FUNCAO_ESTADO_MEMBRO,
    TIPO_MENSAGEM_CCN,
    ERRO_REGISTO,
    TIPO_REGISTO,
    SITUACAO_EXCLUSAO,
    MOTIVO_EXCLUSAO,
    SITUACAO_AVISO_ILIQ,
    ESTADO_AVISO_ILIQ,
    CODIGO_ERRO_AVISO_ILIQ,
    SITUACAO_RESTITUICAO,
    SITUACAO_RESTITUICAO_C,
    SITUACAO_PEDIDO_EXCEL,
    TIPO_PEDIDO_EXCEL,
    TIPO_NOTIFICACAO,
    TIPO_NOTIFICACAO_C,
    TIPO_AVISO_NETP,
    TIPO_AVISO_NETP_C,
    SITUACAO_NOTIF,
    SITUACAO_NOTIF_C
    ;
}
